import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";
import axios from 'axios';
import gPdf from "@/components/g-pdf/g-pdf.vue";
import ConsultarOrcamentoPDF from '../../../ConsultarOrcamento/PDF/ConsultarOrcamentoPDF';
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import { defineComponent } from "vue";
import OrcamentoSequenciaController from "@/shared/controllers/orcamentoSequencia/orcamentoSequenciaController";

const name = 'OrcamentoFinalRepeticao'

export class PhotoService {
  async getImage(OrcamentoSelecionado, images) {
    await axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetImagesByOrcamentoId/${OrcamentoSelecionado}`,
    }) .then((response) => {
      images = response.data.data
    })
    .catch(() => {
    });

    return images
  }
}

export default defineComponent({
  name,

  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm,
    'g-pdf': gPdf,
    'ConsultarOrcamentoPDF': ConsultarOrcamentoPDF
   },

  props: { },

  mounted () {
    var OrcamentoId = this.$route.params.id;
    this.OrcamentoSelecionado = OrcamentoId;
    this.InformacoesCaracteristicas();
    this.InformacoesClienteByOrcamentoId();
    this.InformacoesLoteFreteByOrcamentoId();
    this.InformacoesOrcamentoComponenteByOrcamentoId();
    this.InformacoesOrcamentoProdutoByOrcamentoId();
    this.InformacoesOrcamentoQuantidadeByOrcamentoId();
    this.InformacoesByOrcamentoId();
    this.RotaImagem();
    this.options.push("0");
    this.options.push("1");

    this.getOrcamentoSequencia()



    this.chamarImagem()
  },

  galleriaService: null,
  created (){
    this.galleriaService = new PhotoService();
  },

  updated () { },

  data () {
    return {
      MelhorAproveitamento: '',
      AlturaPalete: '',
      LarguraPalete: '',
      ComprimentoPalete: '',
      ObservacaoPalete: '',
      DesabilitaCheckBox: false,
      DescricaoLote: {},
      nomeRepre:'',
      Empresa:'',
      InformacaoClienteArray:[],
      InformacaoLoteFreteArray:[],
      InformacaoOrcamentoComponenteArray:[],
      InformacaoOrcamentoProdutoArray:[],
      InformacaoOrcamentoQuantidadeArray: [],
      options: [],
      orcamento:null,
      OrcamentoEmbalagem: [],
      OrcamentoEmbalagemCaixaColetiva: [],
      OrcamentoEmbalagemDescOutros: [],
      OrcamentoEmbalagemFilme: [],
      OrcamentoEmbalagemOutros: [],
      OrcamentoEmbalagemPalete: [],
      OrcamentoGerais: [],
      ObservacoesGerais: '',
      OrcamentoGeraisFsc: [],
      OrcamentoGeraisLegislacao: [],
      OrcamentoSelecionado: null,
      OrcaQuantidade: [],
      OrcaQuantidadeDiaCarregamento: [],
      RazaoSocialText:null,
      riscoFacaProt: [],
      styleImg: 'width: 400px',
      caminhoImagem: '',
      InformacaoProdutosSequencia: [],
      images:{
        arquivo:'',
        arquivobase64: '',
        files: '',
        id: '',
        produto:'',
        },
        renderiza: false,
        executarvisualizacao: 0,
        ICMS:null,
        IPI: null,
        PisCofins: null,
        temLote: false,
        temSequencia: false,
        papelSeda: false,
        medidaPapelSeda: '',
        medidaPapelSeda2: '',
      }
  },

  methods: {
    getOrcamentoSequencia(){
      OrcamentoSequenciaController.GetOrcamentoSequenciaByOrcamentoId(this.$route.params.id).requisicao
      .then(res => {
        this.InformacaoProdutosSequencia = res.data.data.informacaoProdutosSequencia
      });
    },
    RetornaQtdLinha1() {
      return !this.temLote ? "3" : "2"
    },
    RetornaQtdLinha2() {
      return !this.temSequencia ? "3" : "2"
    },



    GridSequencia1(){
      return !this.temLote ? "3 / 1 / 4 / 2" : "2 / 2 / 3 / 3"
    },
    GridSequencia2(){
      return !this.temLote ? "2 / 2 / 3 / 3" : "2 / 1 / 3 / 2"
    },
    GridSequencia3(){
      return !this.temLote ? "2 / 1 / 3 / 2" : "1 / 4 / 2 / 5"
    },
    GridSequencia4(){
      return !this.temLote ? "1 / 5 / 2 / 6" : "1 / 4 / 2 / 5"
    },
    GridDescricaoSequencia1(){
      return !this.temLote ? "3 / 2 / 4 / 3" : "3 / 1 / 4 / 2"
    },
    GridDescricaoSequencia2(){
      return !this.temLote ? "2 / 3 / 3 / 4" : "2 / 2 / 3 / 3"
    },
    GridDescricaoSequencia3(){
      return !this.temLote ? "2 / 2 / 3 / 3" : "2 / 1 / 3 / 2"
    },
    GridDescricaoSequencia4(){
      return !this.temLote ? "1 / 6 / 2 / 7" : "1 / 5 / 2 / 6"
    },

    novo_orcamento(){
      this.$router.push('/produto-repeticao-inicio')
    },
    consultarorcamento(){
      this.$router.push('/consultar-orcamento')
    },


    RotaImagem(){
      OrcamentoController.GetRotaImagemProduto(this.$route.params.id).requisicao
      .then(res => {
        const urlBase = window.location.host
        if(res.data.data === 'erro'){
          this.erro(undefined)
          return
        }
        this.caminhoImagem = `http://${urlBase}/${res.data.data}`;
        this.styleImg = 'width: 400px'

      })
    },

    erro(e){
      if(e == undefined){
        this.caminhoImagem = require('@/assets/imgs/Ilustracao_Nenhuma_Img.svg')
        this.styleImg = 'width: 100px'
      }
    },

    InformacoesClienteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByOrcamento/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.InformacaoClienteArray = response.data.data
        this.ICMS = this.InformacaoClienteArray.icms
        this.IPI = this.InformacaoClienteArray.ipi
        this.PisCofins = this.InformacaoClienteArray.pisCofins
        this.incentivos()
      })
      .catch(() => {
      });
    },

    incentivos(){
      this.incentivos
      if (this.ICMS === true){
      this.ICMS = ("ICMS   ")
      } else{
      this.ICMS = ("")
      }

      if (this.IPI === true){
      this.IPI = ("IPI   ")
      } else{
      this.IPI = ("")
      }

      if (this.PisCofins === true){
      this.PisCofins = ("PisCofins")
      } else{
        this.PisCofins = ("")
      }
    },

    InformacoesLoteFreteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `LoteFrete/GetLoteFreteFinalByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.InformacaoLoteFreteArray = response.data.data
        this.riscoFacaProt = response.data.data.RiscoFacaPrototipo;
        if (this.InformacaoLoteFreteArray.informacaoLoteText !== 'Não'){
          this.temLote = false
        }else{
          this.temLote = true
        }
        if(this.InformacaoLoteFreteArray.sequencia != false){
          this.temSequencia = false
        }else{
          this.temSequencia = true
        }
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoComponenteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/GetComponenteByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.InformacaoOrcamentoComponenteArray = response.data.data

        this.DesabilitaCheckBox = true;

        this.InformacaoOrcamentoComponenteArray.forEach((r)=>{
          r.embalagens = []
          r.embalagemEspecificaFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
          r.embalagemEspecificaCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
          r.embalagemEspecificaPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
          r.embalagemEspecificaPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadePapelEmbrulho}`) : ''
          r.quantidadeOutros == null || 0  ? '' : r.embalagens.push(r.descricaoEmbalagemOutros == null || '' ? 'Outros -' : r.descricaoEmbalagemOutros + `${r.quantidadeOutros}`) 

    })
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoProdutoByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoProduto/GetOrcamentoProdutoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.InformacaoOrcamentoProdutoArray = response.data.data
      })
      .catch(() => {
      });
    },

    InformacoesOrcamentoQuantidadeByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoQuantidade/GetOrcamentoQuantidadeByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.InformacaoOrcamentoQuantidadeArray = response.data.data
        this.OrcaQuantidade = response.data.data
        this.OrcaQuantidadeDiaCarregamento = response.data.data
        this.OrcaQuantidadeDiaCarregamento  = this.dataCarregamento(this.OrcaQuantidadeDiaCarregamento)
      })
     .catch(() => {
      });
    },

    InformacoesByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoById/Get/${this.OrcamentoSelecionado}`,
     })
     .then((response) => {
        this.InformacaoOrcamentoArray = response.data.data
        this.nomeRepre = response.data.data.nomeRepresentante
        this.Empresa = response.data.data.nome
        this.orcamento = response.data.data.codigoExterno
      })
     .catch(() => {
      });
    },

    InformacoesCaracteristicas(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetCaracteristicasProdutoFinalByOrcamentoId/Get/${this.OrcamentoSelecionado}`,
      })
      .then((response) => {
        this.OrcamentoGeraisFsc = response.data.data.fsc;
        this.OrcamentoGeraisLegislacao = response.data.data.legislacao;
        this.OrcamentoDescricaoSequencia = response.data.data.descricaoSequencia;

        this.OrcamentoEmbalagemFilme = response.data.data.embalagemEspecificaFilmeEncolhivel;
        this.OrcamentoEmbalagemCaixaColetiva = response.data.data.embalagemEspecificaCaixaColetiva;
        this.OrcamentoEmbalagemPalete = response.data.data.embalagemEspecificaPalete;
        this.OrcamentoEmbalagemOutros = response.data.data.embalagemOutros;
        this.OrcamentoEmbalagemDescOutros = response.data.data.descricaoOutrasEmbalagens;
        this.ObservacoesGerais = response.data.data.observacoesGerais
        this.papelSeda = response.data.data.papelSeda
        this.medidaPapelSeda = response.data.data.medidaPapelSeda 
        this.medidaPapelSeda2 = response.data.data.medidaPapelSeda2

        let alturaPalete = response.data.data.alturaPalete;
        let larguraPalete = response.data.data.larguraPalete;
        let comprimentoPalete = response.data.data.comprimentoPalete;

        this.MelhorAproveitamento = response.data.data.melhorAproveitamento
        this.AlturaPalete =  alturaPalete ?  alturaPalete + ' cm' : '--';
        this.LarguraPalete = larguraPalete ?  larguraPalete + ' cm' : '--';
        this.ComprimentoPalete = comprimentoPalete ?  comprimentoPalete + ' cm' : '--';
        this.ObservacaoPalete = response.data.data.observacaoPalete;

        this.DescricaoLote = response.data.data.lote;
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },



    gerarPdf(){
      this.generatePdf()
    },

    generatePdf() {
      this.executarvisualizacao++
    },

    pdfFinal(){
        this.renderiza = true
        this.executarvisualizacao++
        this.OrcamentoSelecionado = this.$route.params.id
    },

    async chamarImagem(){
      this.images = await this.galleriaService.getImage(this.OrcamentoSelecionado, this.images)
    },

    dataCarregamento(diasCarregamento){
      diasCarregamento = diasCarregamento.map(obj=>{
        if(!obj.dataCarregamentoFormato){
          obj.dataCarregamentoFormato = ("N/A")
        }
        return diasCarregamento
      })
      return diasCarregamento
    }
  },

  computed: { },
});